import React from "react";
import '../notificationsTabs/NotificationsTab.css'

const NotificationsTab = () => {
  return (
    <div className="tabs-detail-sec setting-tab">
      <div className="notification-box">
        <div className="heading-head mb-3">
            <div className="d-flex align-items-center justify-content-between">
                <h2 className="mb-0">Notification Settings</h2>
            </div>
        </div>
        <div className="noti-bottom-sec">
            <div className="noti-box d-flex mb-3 align-items-center justify-content-between">
                <p>New Appointments</p>
                <div className="toggle-menu-radio">
                    <div className='toggle-radio'>
                        <label className="switch">
                        <input type="checkbox"  />
                        <span className="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>
            <div className="noti-box d-flex mb-3 align-items-center justify-content-between">
                <p>Upcoming Appointments</p>
                <div className="toggle-menu-radio">
                    <div className='toggle-radio'>
                        <label className="switch">
                        <input type="checkbox"  />
                        <span className="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>
            <div className="noti-box d-flex mb-3 align-items-center justify-content-between">
                <p>Cancellations</p>
                <div className="toggle-menu-radio">
                    <div className='toggle-radio'>
                        <label className="switch">
                        <input type="checkbox"  />
                        <span className="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>
            <div className="noti-box d-flex mb-3 align-items-center justify-content-between">
                <p>New Followers</p>
                <div className="toggle-menu-radio">
                    <div className='toggle-radio'>
                        <label className="switch">
                        <input type="checkbox"  />
                        <span className="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>
            <div className="noti-box d-flex mb-3 align-items-center justify-content-between">
                <p>Lust Story Updates</p>
                <div className="toggle-menu-radio">
                    <div className='toggle-radio'>
                        <label className="switch">
                        <input type="checkbox"  />
                        <span className="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationsTab;
